var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.71 1.28977C23.575 1.15544 23.4045 1.06244 23.2185 1.0217C23.0325 0.980952 22.8388 0.994161 22.66 1.05977L0.660001 9.05977C0.470269 9.13173 0.306921 9.25972 0.191652 9.42672C0.0763829 9.59373 0.0146484 9.79185 0.0146484 9.99477C0.0146484 10.1977 0.0763829 10.3958 0.191652 10.5628C0.306921 10.7298 0.470269 10.8578 0.660001 10.9298L9.25 14.3598L15.59 7.99977L17 9.40977L10.63 15.7798L14.07 24.3698C14.1441 24.5558 14.2724 24.7154 14.4382 24.8277C14.604 24.94 14.7997 25 15 24.9998C15.2021 24.9956 15.3982 24.9303 15.5624 24.8125C15.7266 24.6947 15.8513 24.5299 15.92 24.3398L23.92 2.33977C23.9881 2.16285 24.0046 1.9702 23.9674 1.78429C23.9302 1.59839 23.8409 1.42688 23.71 1.28977Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.9a2cc6ca8854ba7f793337757e4482c3.svg";
export { ForwardRef as ReactComponent };